import { Icon } from '@types';

export const Trash = ({ customStyles, handleClick }: Icon) => {
	return (
		<svg
			className={customStyles}
			onClick={handleClick}
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			fill="none"
			viewBox="0 0 24 24"
		>
			<mask
				id="mask0_59755_165"
				style={{ maskType: 'alpha' }}
				width="18"
				height="21"
				x="3"
				y="2"
				maskUnits="userSpaceOnUse"
			>
				<path
					fill="#000"
					d="M10.164 3.75a.61.61 0 00-.508.313L9.031 5h5.899l-.625-.938a.61.61 0 00-.508-.312h-3.633zM16.375 5h3.75c.313 0 .625.313.625.625a.642.642 0 01-.625.625h-.742l-.977 13.945c-.117 1.328-1.172 2.305-2.5 2.305H8.055a2.508 2.508 0 01-2.5-2.305L4.578 6.25h-.703a.617.617 0 01-.625-.625c0-.313.273-.625.625-.625H7.586l1.016-1.602a1.837 1.837 0 011.562-.898h3.633c.625 0 1.25.352 1.601.898L16.375 5zm1.758 1.25H5.828l.977 13.867c.039.625.586 1.133 1.25 1.133h7.851c.664 0 1.211-.508 1.25-1.133l.977-13.867z"
				></path>
			</mask>
			<g mask="url(#mask0_59755_165)">
				<path fill="#008635" d="M0 0H24V24H0z"></path>
			</g>
		</svg>
	);
};
